export const checkIsIndeterminate = (cargoItemsIds: number[], selectedCargoItems: Set<number>) => {
  let result = false;

  for (const cargoItemId of cargoItemsIds) {
    if (selectedCargoItems.has(cargoItemId)) {
      result = true;
      break;
    }
  }

  return result;
};
